<template>
    <h3 class="sub-sub-header" :id="slugify(content)" v-html="$t(content)"></h3>
</template>

<script>
import { slugify } from '@/mixins/helper';
export default {
    name: 'SubSubHeader',
    methods: { slugify },
    props: {
        content: String,
    },
};
</script>

<style scoped>
.sub-sub-header {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 2px;
    margin-top: 4px;
    scroll-margin-top: 20px;
}
</style>
